import { useEffect, useState } from "react";
import { Medal, Trophy } from "lucide-react";
import api from "../api";

const RANK_COLORS = ["text-amber-400", "text-gray-300", "text-amber-700"];

export const PodiumSection = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/podium").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return null;
  const entries = data.entries;
  const hasScores = entries.some((e) => e.total > 0);

  return (
    <section data-testid="podium-section">
      <h2 className="font-display text-2xl text-white mb-2 flex items-center gap-2">
        PODIUM {data.year} <Medal size={18} className="text-[#FF3B30]" />
      </h2>
      {!hasScores ? (
        <p className="bg-[#14141A] border border-[#2E2E3A] p-3 text-xs text-[#B0B0B4]">
          Aucun défi mensuel ni duel gagné en {data.year} pour l'instant — le trône est à prendre !
        </p>
      ) : (
        <div className="bg-[#14141A] border border-[#2E2E3A] divide-y divide-white/5">
          {entries.map((e, i) => (
            <div key={e.name} data-testid={`podium-rank-${i + 1}`}
              className={`px-4 py-2.5 flex items-center gap-3 ${e.is_me ? "bg-[#FF3B30]/5" : ""}`}>
              <span className={`font-display text-xl w-6 ${RANK_COLORS[i] || "text-[#B0B0B4]"}`}>{i + 1}</span>
              <div className="flex-1">
                <p className={`text-sm font-semibold ${e.is_me ? "text-[#FF3B30]" : "text-white"}`}>
                  {e.is_me ? "Toi" : e.name}
                </p>
                <p className="text-[#B0B0B4] text-[11px]">
                  {e.defis} défi{e.defis > 1 ? "s" : ""} mensuel{e.defis > 1 ? "s" : ""} · {e.duels} duel{e.duels > 1 ? "s" : ""} gagné{e.duels > 1 ? "s" : ""}
                </p>
              </div>
              <span className="flex items-center gap-1.5 font-display text-2xl text-white">
                {i === 0 && e.total > 0 && <Trophy size={16} className="text-amber-400" />}
                {e.total}
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
